module.exports = __webpack_public_path__ + "img/bg3.e1d2d5b4.png";